import { notification } from 'antd';

export const showError = (message: string) => {
  notification.error({
    message: 'Error',
    description: message,
    duration: 2
  });
};

/**
 * Confirmation that something worked.
 *
 * Deliberately transient. "It worked" is only useful for the moment after it
 * happens, so it does not belong in a banner in the page flow -- one that stays
 * put until you navigate away keeps occupying layout for information nobody is
 * still reading.
 *
 * Only for success. Anything the user may need to act on -- a warning, a
 * partial result, an error -- should stay on screen; use a banner or the
 * relevant validation surface for those.
 */
export const showSuccess = (message: string) => {
  notification.success({
    message: 'Done',
    description: message,
    duration: 3
  });
};
